import dynamic from 'next/dynamic'
import { CarTrafficIcon } from 'src/components/insights/icons/car-traffic'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/car-traffic.png'

const CarTraffic = dynamic(() => import('src/components/insights/car-traffic/content'), {
  ssr: false,
})

export const CarTrafficWidget: InsightBuilderWidget = {
  id: 'car-traffic',
  name: 'Car Traffic',
  type: 'Car Traffic',
  icon: CarTrafficIcon,
  component: CarTraffic,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
